(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ol-anniversary-notice"]) return;
  try {
    
if(!customElements.get('ol-ann-notice')){
customElements.define('ol-ann-notice',class extends HTMLElement{
connectedCallback(){
if(this.ready)return;this.ready=true;
const dialog=this.querySelector('dialog');if(!dialog||!dialog.showModal)return;
const key='ol-ann-20261006-dismissed';
const active=()=>Date.now()<Date.parse('2026-10-11T00:00:00+08:00');
let previous=null;
const open=()=>{if(!active()||dialog.open)return;previous=document.activeElement;dialog.showModal();};
const remember=()=>{try{sessionStorage.setItem(key,'1')}catch(e){}};
dialog.addEventListener('close',()=>{remember();if(previous&&previous.isConnected)previous.focus();});
this.querySelectorAll('[data-close]').forEach(b=>b.addEventListener('click',()=>dialog.close()));
dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}});
this.openHandler=e=>{if(e.target.closest('[data-ol-ann-open]'))open();};
document.addEventListener('click',this.openHandler);
const shop=dialog.querySelector('.ol-ann-shop');if(shop)shop.addEventListener('click',remember);
let dismissed=false;try{dismissed=sessionStorage.getItem(key)==='1'}catch(e){}
if(!dismissed&&this.dataset.editor!=='true')this.timer=setTimeout(open,600);
}
disconnectedCallback(){clearTimeout(this.timer);document.removeEventListener('click',this.openHandler);}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shipping-notice-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shipping-notice-popup')) {
    class ShippingNoticePopup extends HTMLElement {
      connectedCallback() {
        const noticeId = this.dataset.noticeId || 'default';
        const expiresAt = this.dataset.expiresAt;
        const storageKey = 'often-light-notice-' + noticeId;
        if (expiresAt) {
          const now = new Date();
          const expiry = new Date(expiresAt);
          if (!isNaN(expiry.getTime()) && now >= expiry) { return; }
        }
        let dismissed = false;
        try { dismissed = window.localStorage.getItem(storageKey) === '1'; } catch (_) { dismissed = false; }
        if (dismissed) return;
        const backdrop = this.querySelector('.notice-popup__backdrop');
        const closeBtn = this.querySelector('.notice-popup__close');
        const okBtn = this.querySelector('.notice-popup__ok');
        const ctaLink = this.querySelector('.notice-popup__cta');
        const previousActiveElement = document.activeElement;
        const dismiss = () => {
          try { window.localStorage.setItem(storageKey, '1'); } catch (_) {}
          this.setAttribute('hidden', '');
          document.body.style.overflow = '';
          document.removeEventListener('keydown', onKeydown);
          if (previousActiveElement && previousActiveElement.focus) { previousActiveElement.focus(); }
        };
        const onKeydown = (e) => {
          if (e.key === 'Escape') { e.preventDefault(); dismiss(); }
        };
        setTimeout(() => {
          this.removeAttribute('hidden');
          document.body.style.overflow = 'hidden';
          document.addEventListener('keydown', onKeydown);
          if (okBtn) okBtn.focus();
        }, 500);
        if (closeBtn) closeBtn.addEventListener('click', dismiss);
        if (okBtn) okBtn.addEventListener('click', dismiss);
        if (backdrop) backdrop.addEventListener('click', dismiss);
        if (ctaLink) ctaLink.addEventListener('click', () => {
          try { window.localStorage.setItem(storageKey, '1'); } catch (_) {}
          document.body.style.overflow = '';
        });
      }
    }
    customElements.define('shipping-notice-popup', ShippingNoticePopup);
  }

  } catch(e) { console.error(e); }
})();
})();
